import { render, staticRenderFns } from "./BinDeleteModal.vue?vue&type=template&id=c24c1aca"
import script from "./BinDeleteModal.vue?vue&type=script&lang=ts"
export * from "./BinDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports